import { ProfileData } from '../types';

export const userAData: ProfileData = {
  profile: {
    title: "You are in the Nagpal world...",
    name: "Nagpal - your neighbourhood astronaut by night, baddie on sight. ",
    searchPlaceholder: "Let's plan our church street date?"
  },
  photos: [
    {
      url: "/assets/userA/WhatsApp Image 2025-07-25 at 13.40.04.jpeg",
      alt: "Profile photo 1",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      url: "/assets/userA/WhatsApp Image 2025-07-25 at 13.40.04 (1).jpeg",
      alt: "Profile photo 2", 
      gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)"
    },
    {
      url: "/assets/userA/WhatsApp Image 2025-07-25 at 13.40.05.jpeg",
      alt: "Profile photo 3",
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    },
    {
      url: "/assets/userA/WhatsApp Image 2025-07-25 at 13.40.05 (1).jpeg",
      alt: "Profile photo 4",
      gradient: "linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)"
    },
    {
      url: "/assets/userA/WhatsApp Image 2025-07-25 at 13.40.05 (2).jpeg",
      alt: "Profile photo 5",
      gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)"
    },
    {
      url: "/assets/userA/WhatsApp Image 2025-07-25 at 13.40.06.jpeg",
      alt: "Profile photo 6",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    }
  ],
  cards: [
    {
      id: "numbers",
      type: "numbers",
      title: "Numbers",
      items: [
        { label: "IG Followers", value: "1543" },
        { label: "LinkedIn Followers", value: "7533" },
        { label: "Twitter Followers", value: "well 👀" },
        { label: "Roadside Followers", value: "17 (OKAY!)" }
      ],
      special: {
        label: "Human Number",
        value: "#7,284,719,358"
      },
      metadata: {
        description: "Social media presence and follower counts",
        personalContext: "I'm not obsessed with numbers, but look at the amount of people on this world",
        storyBehind: "Nothing as such",
        emotionalTone: "Baddie",
        conversationStarters: [
          "What;s your poison?",
          "Do you think follower count matters?"
        ],
        aiGuidance: "Be flirty and baddie about social metrics.",
        tags: ["social media", "community", "connections", "authentic"],
        importance: "medium"
      }
    },
    {
      id: "interactions",
      type: "interactions",
      title: "App Interactions of the past 7 days?",
      subtitle: "Some cool things.",
      interactions: [
        {
          app: "BlinkIt",
          activity: "Ordered eggs for the Protein girly meal",
          icon: "🥚"
        },
        {
          app: "Rapido",
          activity: "Spent 8 minutes sweet talking the Driver to start the ride",
          icon: "🛵"
        },
        {
          app: "Messages",
          activity: "Voice-texted my mom while walking, accidentally sent \"love you too, buy milk\" to my boss",
          icon: "💬"
        },
        {
          app: "Tennis Buddy",
          activity: "Looking for a tennis session mate",
          icon: "🎾"
        },
        {
          app: "Water Reminder",
          activity: "Set reminder to drink more water, ignored reminder 6 times",
          icon: "💧"
        }
      ],
      "metadata": {
        "description": "A week in the life of a functional disaster",
        "personalContext": "My app usage says more about me than my zodiac sign ever could",
        "storyBehind": "I started tracking my app usage to prove I'm not addicted to my phone (plot twist: I am)",
        "emotionalTone": "chaotically authentic",
        "conversationStarters": [
          "Which app interaction is most relatable?",
          "What's your most embarrassing text mishap?",
          "Are you a hydration reminder ignorer too?"
        ],
        "aiGuidance": "This showcases my real life - messy, funny, and full of protein",
        "tags": ["everyday-chaos", "relatable-content", "tennis-enthusiast", "hydration-challenged"],
        "importance": "high"
      }
    },
    {
      id: "spotify",
      type: "embed",
      embedType: "spotify",
      icon: "🎵",
      title: "Currently Playing",
      subtitle: "Saiyaara Title Track",
      service: "Spotify",
      iframeUrl: "https://open.spotify.com/embed/track/1D35BJlymlh6OLD75WupSF?utm_source=generator",
      metadata: {
        description: "The soundtrack to my inexistent lover thoughts",
        personalContext: "I love theeee movie (Saiyaara). I've watched it twice already. ",
        storyBehind: "You can always find me listening to this. ",
        emotionalTone: "chill but secretly deep, mysterious, goth lover",
        conversationStarters: [
          "What's your go-to focus music?",
          "Do you judge people by their playlists? (you should)",
          "Lofi or classical for productivity?"
        ],
        aiGuidance: "Music taste reveals my vibe - laid back but with hidden complexity",
        tags: ["lofi-enthusiast", "music-as-therapy", "background-soundtrack", "productivity-companion"],
        importance: "medium"
      }
    },
    {
      id: "hulu-helstrom", 
      type: "embed",
      embedType: "hulu",
      icon: "📺",
      title: "Helstrom",
      subtitle: "Currently Binging",
      service: "Hulu",
      htmlContent: "<div><div style=\"left: 0; width: 100%; height: 140px; position: relative;\"><iframe src=\"https://cdn.iframe.ly/api/iframe?card=small&app=1&url=https%3A%2F%2Fwww.hulu.com%2Fseries%2Fhelstrom-363e6454-0b7d-433c-b29b-d4a6059504e3&key=2bf1e6178d61dd00feecb75a6a2e985c\" style=\"top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;\" allowfullscreen></iframe></div></div>",
      scriptUrl: "https://cdn.iframe.ly/embed.js",
      metadata: {
        description: "My current supernatural obsession",
        personalContext: "I watch this when I need to feel like my family is actually normal",
        storyBehind: "Started it because of the cool poster, stayed for the dysfunctional family dynamics",
        emotionalTone: "darkly intrigued",
        conversationStarters: [
          "Are you into supernatural shows?",
          "Team Daimon or Team Ana?",
          "Do you also watch scary things alone at night?"
        ],
        aiGuidance: "Shows my appreciation for the darker side of storytelling",
        tags: ["binge-worthy", "supernatural-fan", "horror-curious", "night-watcher"],
        importance: "medium"
      }
    },
    {
      id: "weekend-quote",
      type: "quote",
      title: "\"Her Last Weekend\"",
      quote: "Fixed my leaky faucet, then took a wine bubble bath to celebrate.",
      author: "Saturday done right!",
      metadata: {
        description: "Evidence of my adulting capabilities and self-care practices",
        personalContext: "This pretty much sums up my ideal weekend - fixing something then celebrating like I rebuilt civilization",
        storyBehind: "Actually spent three hours watching YouTube videos before attempting the faucet fix",
        emotionalTone: "proud yet self-deprecating",
        conversationStarters: [
          "What's your biggest DIY triumph?",
          "Bath person or shower person?",
          "What do you celebrate with after adult achievements?"
        ],
        aiGuidance: "Highlights my practical side paired with appreciation for life's small victories",
        tags: ["weekend-warrior", "self-care-queen", "DIY-dabbler", "wine-enthusiast"],
        importance: "medium"
      }
    },
    {
      id: "maps",
      type: "embed",
      embedType: "map",
      icon: "🗺️",
      title: "Connecting the world",
      subtitle: "Italy • Korea • Bangalore",
      service: "Interactive Map",
      useInteractiveMap: true,
      mapLocations: [
        { name: "Rome, Italy", lat: 41.9028, lng: 12.4964 },
        { name: "Seoul, Korea", lat: 37.5665, lng: 126.9780 },
        { name: "Bangalore, India", lat: 12.9716, lng: 77.5946 }
      ],
      metadata: {
        description: "My personal geography of connections",
        personalContext: "These places hold pieces of my heart and story",
        storyBehind: "Rome, Seoul for work, Bangalore because it's home",
        emotionalTone: "worldly yet rooted",
        conversationStarters: [
          "Which of these places would you visit first?",
          "What's your favorite place you've traveled to?",
          "Do you believe places shape who we are?"
        ],
        aiGuidance: "Shows my global perspective while maintaining deep connection to Bangalore",
        tags: ["globe-trotter", "culture-collector", "home-is-where", "wanderlust"],
        importance: "high"
      }
    },
    {
      id: "art",
      type: "photos",
      title: "Art",
      artImages: [
        "/assets/userA/art/216fac64-a5e5-4dca-bf02-372e1fe771ac.jpg",
        "/assets/userA/art/e7a55504-a49a-4de0-a29f-dfa1707a0d7d.jpg"
      ],
      metadata: {
        description: "Visual expressions that speak to my soul",
        personalContext: "Art that makes me feel seen in inexplicable ways",
        storyBehind: "Collected these pieces that represent different facets of the world. ",
        emotionalTone: "contemplative and expressive",
        conversationStarters: [
          "What does this art make you feel?",
          "Are you drawn to abstract or representational art?",
          "If your personality was a piece of art, what would it look like?"
        ],
        aiGuidance: "Talk about my gothic art and my similar likings.",
        tags: ["art-lover", "modern-aesthetic", "visual-thinker", "gallery-wanderer"],
        importance: "medium"
      }
    },
    {
      id: "hulu-indian-boy",
      type: "embed",
      embedType: "hulu",
      icon: "📺",
      title: "A Nice Indian Boy",
      subtitle: "YOU SHOULD SEE THIS",
      service: "Hulu",
      htmlContent: "<div><div style=\"left: 0; width: 100%; height: 0; position: relative; padding-bottom: 52.5%; padding-top: 120px;\"><iframe src=\"https://cdn.iframe.ly/api/iframe?app=1&url=https%3A%2F%2Fwww.hulu.com%2Fmovie%2Fa-nice-indian-boy-70117cda-b569-422a-a682-e1fff59da1bb&key=2bf1e6178d61dd00feecb75a6a2e985c\" style=\"top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;\" allowfullscreen></iframe></div></div>",
      scriptUrl: "https://cdn.iframe.ly/embed.js",
      metadata: {
        description: "THE movie that gets the cultural tug-of-war in my head",
        personalContext: "I relate to this on a spiritual level - the ALL CAPS recommendation is not an exaggeration",
        storyBehind: "Made all my friends watch this, prepared a whole Indian dinner to go with it",
        emotionalTone: "passionate and validating",
        conversationStarters: [
          "Have you seen this masterpiece yet?",
          "How do you balance tradition and modern life?",
          "What movie made you feel truly seen?"
        ],
        aiGuidance: "Highlights my connection to cultural identity and appreciation for stories that bridge worlds",
        tags: ["must-watch", "cultural-identity", "representation-matters", "movie-evangelist"],
        importance: "high"
      }
    },
    {
      id: "spotify-lana",
      type: "embed",
      embedType: "spotify",
      icon: "🎵",
      title: "Lana Del Rey Vibes",
      subtitle: "West Coast dreaming",
      service: "Spotify",
      iframeUrl: "https://open.spotify.com/embed/track/2mdEsXPu8ZmkHRRtAdC09e?utm_source=generator",
      metadata: {
        description: "For my dramatic moods and main character moments",
        personalContext: "I listen to Lana ALWAYS",
        storyBehind: "Discovered during a beach road trip, now permanently associated with sunset drives",
        emotionalTone: "nostalgic yet present",
        conversationStarters: [
          "Cinnamon Girl or West Coast?",
          "What artist transports you to another world?",
          "Do you have a soundtrack for different moods?"
        ],
        aiGuidance: "Shows my LANA fandom",
        tags: ["lana-lover", "mood-music", "dreamy-aesthetics", "cinematic-life"],
        importance: "medium"
      }
    },
    {
      id: "goodreads",
      type: "embed",
      embedType: "goodreads",
      icon: "📖",
      title: "Books & Reading",
      subtitle: "Recent reads and ratings",
      service: "Goodreads",
      iframeUrl: "https://goodreads.com/widgets/user_widget?user_id=91775248-nagpal",
      books: [
        {
          title: "The Kind Worth Killing",
          author: "Peter Swanson",
          rating: 4,
          status: "Currently Reading",
          cover: "📚"
        },
        {
          title: "Everyone in My Family Has Killed Someone",
          author: "Benjamin Stevenson",
          rating: 4,
          status: "Recently Finished",
          cover: "🔍"
        },
        {
          title: "The Craftsman",
          author: "Sharon J. Bolton",
          rating: 3,
          status: "Recently Finished",
          cover: "🎭"
        }
      ],
      metadata: {
        description: "Literary evidence that I enjoy psychological thrillers and mysteries",
        personalContext: "These books reveal my fascination with the darker side of human nature (don't be alarmed)",
        storyBehind: "Started reading thrillers after watching too many crime documentaries",
        emotionalTone: "intellectually curious with a dash of darkness",
        conversationStarters: [
          "Have you read any of these books?",
          "Do you think thriller readers make suspicious first dates?",
          "What does your reading list say about you?"
        ],
        aiGuidance: "Highlights my analytical mind and appreciation for psychological complexity",
        tags: ["book-worm", "thriller-enthusiast", "mystery-lover", "night-reader"],
        importance: "high"
      }
    },
    {
      id: "sculpture",
      type: "image",
      content: "🗿",
      height: "280px",
      background: "linear-gradient(135deg, #e0e0e0, #bdbdbd)",
      fontSize: "48px",
      metadata: {
        description: "The emoji that best represents my stoic exterior (and my messy dead life)",
        personalContext: "Sometimes I just feel like a stone head watching the world go by",
        storyBehind: "Inside joke with friends who say I make this exact face when thinking deeply",
        emotionalTone: "mysteriously contemplative",
        conversationStarters: [
          "Which emoji represents your essence?",
          "Do you also have a thinking face that scares people?",
          "Ancient artifacts: cool or creepy?"
        ],
        aiGuidance: "Inside joke with friends who say I make this exact face when thinking deeply",
        tags: ["mood-statue", "thinking-face", "silent-observer", "stone-cold-fantastic"],
        importance: "low"
      }
    }
  ]
};